import { render, staticRenderFns } from "./PictogramTileComponent.vue?vue&type=template&id=22b90b44&scoped=true&"
import script from "./PictogramTileComponent.vue?vue&type=script&lang=ts&"
export * from "./PictogramTileComponent.vue?vue&type=script&lang=ts&"
import style0 from "./PictogramTileComponent.vue?vue&type=style&index=0&id=22b90b44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b90b44",
  null
  
)

export default component.exports